import { BODY_BG_IMG } from '@/pages/user/member-detail/member-physiotherapy-info/ExpandContent/DetectionResult';
import { PAIN_AREA_CONFIG } from '@/pages/ai-consultation/components/mark-pain-area';
import cx from './index.module.scss';
import { Form } from 'antd';

interface Props {
  painReliefListProblems: AIDiagnoseSubmitParams['painReliefList'];
  handleDelete: (value: Diagnose, therapyType: AIDiagnose.TherapyType) => void;
}

const PainRelief: React.FC<Props> = ({ painReliefListProblems, handleDelete }) => {
  return (
    <div className={cx('wrapper')}>
      <div className={cx('header')}>
        <div>疼痛舒缓</div>
        <div onClick={() => handleDelete('painReliefList', 'painRelief')}>删除</div>
      </div>

      <div className={cx('content')}>
        <div className={cx('preview-image')}>
          <div className={cx('img-wrapper')}>
            <img className={cx('main-body-bg')} src={BODY_BG_IMG} alt="" />
            <div className={cx('pain-area-wrapper')}>
              <Form.Item name="painReliefList" hidden />
              {Object.keys(PAIN_AREA_CONFIG).map(item => (
                <div
                  className={cx('marker-item', item)}
                  key={item}
                  style={{
                    backgroundImage: `url(${
                      PAIN_AREA_CONFIG[item as AIDiagnose.MarkPainArea]?.[
                        painReliefListProblems?.map(item => item.problem)?.includes(item as AIDiagnose.MarkPainArea)
                          ? 'selectUrl'
                          : 'defaultPlainUrl'
                      ]
                    })`,
                  }}
                ></div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PainRelief;
